import { STORAGE_KEY } from '../Functions/ActivityLogger/util';
import { fetchAccessToken } from '../Functions/fetchAccessToken';
import { getSetup } from '../Functions/getSetup';

export function checkForUpdates(
	url: string,
	fetchOptions: any,
	brand: string,
	label?: boolean
) {
	const checkURL = `${url}/module/delivery/bpca/api/v2/contents?fields-preset=full`;
	let isWaitingForUpdateDelay = false;
	let oldBuildInfo = localStorage.getItem('build-info');
	if (fetchOptions && fetchOptions.headers) {
		fetchOptions.headers['Service-Worker'] = 'false';
		fetchOptions.headers['Cache-Control'] = 'max-age=0';
	}

	async function setFetchOptions() {
		const token = navigator.onLine
			? await fetchAccessToken()
			: localStorage.getItem('accesstoken');
		fetchOptions = {
			method: 'GET',
			headers: {
				'X-Requested-With': 'XMLHttpRequest',
				Authorization: 'Bearer ' + token,
				'Service-Worker': 'false',
			},
		};
	}

	const localStorageKey = 'build-info' + (label ? '-label' : '');
	const setup = getSetup();
	const params = new URLSearchParams(window.location.search);
	const chromebox =
		params.get('chromebox') === 'true' ||
		localStorage.getItem('hardware') === 'Chromebox';

	const reload = async () => {
		console.warn('Update available!');
		isWaitingForUpdateDelay = false;
		await setFetchOptions();
		const url = await fetch(checkURL, fetchOptions);
		const page = await fetch(window.location.href, { method: 'HEAD' });

		if (!url.ok || !page.ok) return;

		if (!label && navigator.onLine) {
			caches.keys().then(keyList =>
				Promise.all(
					keyList.map(key => {
						if (key.includes(brand)) caches.delete(key);
					})
				)
			);
		}

		console.log('[CACHE] reload() called');

		const cacheNames = await caches.keys();
		const precacheNames = cacheNames.filter(name =>
			name.startsWith('did-web-precache')
		);
		console.log('[CACHE] matching precaches:', precacheNames);
		if (precacheNames.length === 0) {
			console.warn('[CACHE] no did-web-precache* cache found');
			location.reload();
			return;
		}
		for (const cacheName of precacheNames) {
			const cache = await caches.open(cacheName);
			console.log(`[CACHE] opened cache: ${cacheName}`);
			const requests = await cache.keys();
			console.log(
				`[CACHE] requests in ${cacheName}:`,
				requests.map(r => r.url)
			);
			const matchPath = '/module/delivery/bpca/api/v2/contents';
			let found = false;
			for (const request of requests) {
				const requestUrl = new URL(request.url);
				console.log('[CACHE] checking request:', {
					cacheName,
					url: requestUrl.href,
				});
				if (requestUrl.pathname === matchPath) {
					found = true;
					console.log('[CACHE] MATCH FOUND → deleting:', {
						cacheName,
						url: requestUrl.href,
					});
					const deleted = await cache.delete(request);
					console.log('[CACHE] delete result:', {
						cacheName,
						url: requestUrl.href,
						deleted,
					});
				}
			}
			if (!found) {
				console.warn(
					`[CACHE] NO MATCH FOUND in ${cacheName} for ${matchPath}`
				);
			}
		}
		console.log('[CACHE] cleanup finished → reloading page');
		location.reload();

	};

	const checkEtag = async () => {
		let etag: string | null = localStorage.getItem('etag');
		try {
			await setFetchOptions();
			const fetchHeaders: Headers = new Headers({
				...fetchOptions.headers,
			});

			// If we have a stored etag, send as header.
			if (etag) {
				fetchHeaders.set('If-None-Match', etag);
			}

			const response = await fetch(checkURL, {
				headers: fetchHeaders,
			});

			// Only treat HTTP 200 as valid update signal
			if (etag && response.status === 200) {
				const newEtag = response.headers.get('Etag');

				if (newEtag && newEtag !== etag) {
					localStorage.setItem('etag', newEtag);
					localStorage.setItem('update-available', 'true');
					reload();
				}
			} else if (!etag && response.status === 200) {
				// Store etag from response.
				etag = response.headers.get('Etag');
				etag && localStorage.setItem('etag', etag);
			}

			const buildInfoResponse = await fetch('./build-info.json', {
				headers: {
					'Service-Worker': 'false',
					'Cache-Control': 'max-age=0',
				},
			});

			if (!buildInfoResponse.ok) return;

			const ct = buildInfoResponse.headers.get('content-type');
			if (!ct?.includes('application/json')) return;
			const newBuildInfo = await buildInfoResponse.json();
			console.log('in front of build info check');
			if (
				oldBuildInfo &&
				new Date(newBuildInfo.timestamp) >
					new Date(JSON.parse(oldBuildInfo).timestamp)
			) {
				if (isWaitingForUpdateDelay) return;

				isWaitingForUpdateDelay = true;
				localStorage.setItem(
					localStorageKey,
					JSON.stringify(newBuildInfo)
				);
				const delay = Math.random() * 10 * 60 * 1000;
				console.log(delay);
				await new Promise((resolve) => setTimeout(resolve, delay));
				reload();
			} else if (!oldBuildInfo) {
				localStorage.setItem(
					localStorageKey,
					JSON.stringify(newBuildInfo)
				);
			}
		} catch (e) {
			console.warn('Error during checkEtag:', e);
		}
	};

	if (!label) checkEtag();

	setInterval(
		() => {
			if (label) {
				if (localStorage.getItem('update-available') === 'true') {
					localStorage.removeItem('update-available');
					reload();
					chromebox &&
					window.dispatchEvent(new CustomEvent('reload-label'));
				}
			} else {
				if (
					sessionStorage.getItem(STORAGE_KEY) === null &&
					navigator.onLine
				) {
					checkEtag();
				}
			}
		},
		2 * 60000 * (label ? 0.1 : 1)
	); // 2 min
}
